import { RangePickerProps } from 'antd/es/date-picker';
import dayjs from 'dayjs';
import { validatePromoCode } from 'src/api';
import { LocaleT } from './enums';
/**
    function to caliptalize strings
    * @param value: string to capitalize
    Example:
    receive: SOME WORD, function returns => Some Word
    receive: some word, function returns => Some Word
*/
export const ucFirst = (value: string) => {
   // empezar todas las palabras con mayuscula incluso si hay un espacio en un nombre o apellido compuesto
   value.replace(/\b\w/g, (val) => val.toUpperCase());
   // creamos arreglo temporal
   const temp = value.split(' ');
   // Se asegura que solo la primer letra de cada palabra comience con mayúscula
   const result = temp.map((key) => {
      return key.charAt(0).toUpperCase() + key.toLowerCase().slice(1);
   });
   return result.join(' ');
};

/**
 * @param value: number to convert to Hour with minutes
 */
export const convertToHourMinutes = (value: number) => {
   const hours: number = value / 60;
   // validate Hours
   if (hours >= 1) {
      // validate if is exactly an Hour
      const getHours = parseInt(String(hours));
      const getMinutes = value - getHours * 60;
      return `${getHours} h ${getMinutes > 0 ? `${getMinutes} min` : ''}`;
   } else {
      // return only minutes
      return `${value} min`;
   }
};

/**
 * @param address: array of google address component
 * @param prop: string to search
 * @param shortName: boolean var
 */
export const getProperties = (
   address: Array<{
      long_name: string;
      short_name: string;
      types: string[];
   }>,
   prop: string,
   shortName = false
) => {
   if (address) return address.find((item: any) => item.types.includes(prop))?.[shortName ? 'short_name' : 'long_name'] || '';
   return '';
};

export const disabledCurrentDate: RangePickerProps['disabledDate'] = (current) => {
   // Can not select days before today and today
   // return current && current < dayjs().subtract(1, 'day').endOf('day');
   return current && current < dayjs().endOf('day');
};

export const emailValidation = (value: string) => {
   const regex = /^(?:[^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*|"[^\n"]+")@(?:[^<>()[\].,;:\s@"]+\.)+[^<>()[\],;:\s@"]{2,63}$/;
   return !!regex.test(value);
};

export const numberValidation = (value: string) => {
   const regex = /^\d+$/;
   return !!regex.test(value);
};

export const getAmountDiscount = (amount: number, discount: number) => {
   return (amount * discount) / 100;
};

export const getAmountByMonth = (amount: number, commission: number, months: number) => {
   return (amount + amount * commission) / months;
};

export const getAmountWithCommision = (amount: number, commission: number) => {
   return amount + amount * commission;
};

export const getTotalDeferred = (option: number, amount: number) => {
   switch (option) {
      case 3:
         return getAmountWithCommision(amount, 0.053);
      case 6:
         return getAmountWithCommision(amount, 0.08);
      case 9:
         return getAmountWithCommision(amount, 0.11);
      default:
         return getAmountWithCommision(amount, 0.14);
   }
};

export const getSellPriceByLocale = (locale: LocaleT) => {
   switch (locale) {
      case 'co':
         return 'sell_price_co';
      case 'en':
         return 'sell_price_usd';
      case 'es-ES':
         return 'sell_price_eur';
      case 'ar':
      case 'pa':
         return 'sell_price_arg';
      case 'pr':
         return 'sell_price_pr';
      case 'cl':
         return 'sell_price_clp';
      case 'pe':
         return 'sell_price_pen';
      default:
         return 'sell_price';
   }
};

export const formatter = (locale: LocaleT) => {
   let currency: string;
   let localeToUse = 'es-MX';
   // Determinamos la moneda según la localización
   switch (locale) {
      case 'en':
      case 'ar':
      case 'pa':
      case 'pr':
         currency = 'USD';
         localeToUse = 'en-US';
         break;
      case 'cl':
         currency = 'CLP'; // Si realmente quieres usar COP, puedes cambiar esto
         localeToUse = locale;
         break;
      case 'co':
         currency = 'COP'; // Si realmente quieres usar COP, puedes cambiar esto
         localeToUse = locale;
         break;
      case 'es-ES':
         currency = 'EUR';
         localeToUse = locale;
         break;
      case 'es':
      default:
         currency = 'MXN';
         localeToUse = 'es-MX'; // <-- este es el cambio importante
   }

   return new Intl.NumberFormat(localeToUse, {
      style: 'currency',
      currency: currency,
   });
};

export const getPrefixEndpoints = (locale: LocaleT) => {
   if (locale === 'en') {
      return locale;
   }
   return 'es';
};

export const getPromo = async (wallets: any, code: string) => {
   //filter wallets
   const wallet = wallets.filter((w: any) => w.code === code);
   if (wallet.length > 0) {
      return wallet[0];
   } else {
      return null;
   }
};
